var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"componentRef",class:[
    'animate__animated',
    _vm.$style.component,
    _vm.placedToRef && _vm.$style.placed,
    _vm.placedToRef && !_vm.canMovePlaced && _vm.$style.immovable,
    _vm.placedToRef && !_vm.keepVisible && 'animate__bounceOut',
    _vm.placedToRef && _vm.keepVisible && 'animate__pulse',
    _vm.hidden && _vm.$style.hidden,
    _vm.isAnimatingWrong && 'animate__wobble',
    _vm.isReturning && _vm.$style.returning
  ],style:({
    zIndex: _vm.isDragging ? 99 : _vm.zIndex
  }),attrs:{"title":_vm.label}},[_c('movable',{attrs:{"target":"componentRef"},on:{"start":_vm.onStart,"move":_vm.onMove,"complete":_vm.onStop}},[_c('ItemGraphics',{attrs:{"imageUrl":_vm.imageUrl,"label":_vm.label,"size":_vm.size}}),_c('img',{class:[_vm.$style.draggableIcon],attrs:{"src":require("../../assets/images/draggable-icon.svg"),"alt":"Draggable icon"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }